import {
  selectCodiceProgramma,
  selectNumeroAvvenimento,
  selectScommesseListByScommessaKey,
} from 'features/ippica/selectors';

import { IppicaScommesseTableRowTestaATesta } from '../../ippicaScommesseTableRow/IppicaScommesseTableRowTestaATesta';
import { IppicaScommesseTableTitles } from '../../ippicaScommesseTableTitles';
import styles from '../IppicaScommesseRenderer.module.scss';
import { useTypedSelector } from 'lib/centralStore';

type IppicaScommesseRendererTestaATestaProps = {
  tipoScommessaKey: 109 | 110;
  isMobile: boolean;
};

export const IppicaScommesseRendererTestaATesta = ({
  tipoScommessaKey,
  isMobile,
}: IppicaScommesseRendererTestaATestaProps) => {
  const codiceProgramma = useTypedSelector(selectCodiceProgramma);
  const numeroAvvenimento = useTypedSelector(selectNumeroAvvenimento);
  const scommesseListByScommessaKey = useTypedSelector(
    selectScommesseListByScommessaKey(`${codiceProgramma}_${numeroAvvenimento}_${tipoScommessaKey}`)
  );

  function composeKeyList(idInfoAggiuntiva: string | undefined) {
    const keyList: { keyCavalloList: string[]; keyQuotaList: string[] } = {
      keyCavalloList: [],
      keyQuotaList: [],
    };

    if (idInfoAggiuntiva) {
      for (let i = idInfoAggiuntiva.length; i > 4; i -= 2) {
        const numeroCavallo = parseInt(idInfoAggiuntiva.substring(i - 2, i), 16);
        if (numeroCavallo !== 0) {
          keyList.keyCavalloList.push(`${codiceProgramma}_${numeroAvvenimento}_${numeroCavallo}`);
        }
      }
    }
    keyList.keyQuotaList.push(`${codiceProgramma}_${numeroAvvenimento}_${tipoScommessaKey}_${idInfoAggiuntiva}_1`);
    keyList.keyQuotaList.push(`${codiceProgramma}_${numeroAvvenimento}_${tipoScommessaKey}_${idInfoAggiuntiva}_2`);
    // Il risultato è già nell'ordine corretto grazie all'inversione iniziale
    return keyList;
  }

  return (
    <>
      {!isMobile && (
        <IppicaScommesseTableTitles
          titles={[{ label: 'Testa A Testa' }]}
          containerClassName={styles.tableTitlesCentered}
        />
      )}
      {scommesseListByScommessaKey?.map((scommessa) => {
        const { idInfoAggiuntiva } = scommessa;
        const { keyQuotaList, keyCavalloList } = composeKeyList(idInfoAggiuntiva);
        return scommessa ? (
          <IppicaScommesseTableRowTestaATesta
            key={scommessa.idInfoAggiuntiva}
            keyCavalloList={keyCavalloList}
            keyQuotaList={keyQuotaList}
          />
        ) : null;
      })}
    </>
  );
};
